export default "__VITE_ASSET__1FDxpERT__"